import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { AcademyService } from "../../../Report/report-services/academy.service";
import { GradeLevelService } from "../../../Report/report-services/grade-level.service";
import { GroupService } from "../../../Report/report-services/group.service";
import { HomeroomService } from "../../../Report/report-services/homeroom.service";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_Student_DigitalID } from "../shared/data.service";
import { RegisterManualEmailRequest } from "../shared/RegisterManualEmailRequest";
import { ManualEmailTableComponent } from "./manual-email-table/manual-email-table.component";
import { ManualStudentTableComponent } from "./manual-student-table/manual-student-table.component";
import { CheckValidActivationsRequest } from "../shared/CheckValidActivationsRequest";
import { DialogService } from "primeng/dynamicdialog";
import { DigitalIdActivationInfoComponent } from "../digital-id-activation-info/digital-id-activation-info.component";

@Component({
	selector: "caass-digital-id-manual-mode",
	templateUrl: "./digital-id-manual-mode.component.html",
	styleUrls: ["./digital-id-manual-mode.component.css"],
})
export class DigitalIdManualModeComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private groupService: GroupService,
		private idService: DataService_Student_DigitalID,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////

	@Output() EmailRefresh: EventEmitter<any> = new EventEmitter();

	subscription: any;

	School: any;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "All Schools";

	LoadingGradeLevel: boolean = true;
	SelectedGradeLevel: any;
	lstGradeLevel: any = [];

	LoadingAcademy: boolean = true;
	SelectedAcademy: any;
	lstAcademy: any = [];

	LoadingHomeroom: boolean = true;
	SelectedHomeroom: any;
	lstHomeroom: any = [];

	LoadingGroup: boolean = true;
	SelectedGroup: any;
	lstGroup: any = [];

	ActiveOptionID: any = 1;
	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	AlreadyPrintedID: any = -1;
	lstAlreadyPrinted: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Digital ID Printed",
		},
		{
			ID: 0,
			Desc: "Digital ID Not Printed",
		},
	];

	Processing: boolean = false;

	loading: boolean = false;
	lstPerson: any[] = [];
	lstToEmail: any[] = [];

	SelectStudentsExpand: boolean = false;
	EmailStudentsExpand: boolean = false;

	@ViewChild(ManualStudentTableComponent)
	StudentRef: ManualStudentTableComponent;

	@ViewChild(ManualEmailTableComponent)
	EmailRef: ManualEmailTableComponent;

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////

	loadGradeLevel() {
		this.LoadingGradeLevel = true;

		var result = this.gradelevelService.loadGradeLevelList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All Grade Levels",
					});
				}

				this.SelectedGradeLevel = this.lstGradeLevel[0];
				this.LoadingGradeLevel = false;
			},
			(error) => {
				this.LoadingGradeLevel = false;
			}
		);
	}

	loadAcademy() {
		this.LoadingAcademy = true;

		var result = this.academyService.loadAcademyList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyId: -1,
						AcademyDesc: "All Academies",
					});
				}

				this.SelectedAcademy = this.lstAcademy[0];
				this.LoadingAcademy = false;
			},
			(error) => {
				this.LoadingAcademy = false;
			}
		);
	}

	loadHomeroom() {
		this.LoadingHomeroom = true;

		var result = this.homeroomService.loadHomeroomList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomId: -1,
						HomeRoom: "All Homerooms",
					});
				}

				this.SelectedHomeroom = this.lstHomeroom[0];
				this.LoadingHomeroom = false;
			},
			(error) => {
				this.LoadingHomeroom = false;
			}
		);
	}

	loadGroup() {
		this.LoadingGroup = true;

		var result = this.groupService.loadGroupList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "All Groups",
					});
				}

				this.SelectedGroup = this.lstGroup[0];
				this.LoadingGroup = false;
			},
			(error) => {
				this.LoadingGroup = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////
	onSearch() {
		this.loading = true;
		this.SelectStudentsExpand = true;

		var result = this.idService.RegisterManualStudentSelectList(
			this.School.SchoolID,
			this.SelectedGradeLevel.GradeLevelID,
			this.SelectedAcademy.AcademyId,
			this.SelectedHomeroom.HomeroomId,
			this.SelectedGroup.GroupID,
			this.ActiveOptionID,
			this.AlreadyPrintedID
		);
		result.subscribe(
			(response: any) => {
				this.lstPerson = response;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////
	onSchoolChange(school) {
		this.School = school;

		//Load Data
		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
	}

	onAddToList(lstSelected: any[]) {
		for (var z = 0; z < lstSelected.length; z++) {
			var next = lstSelected[z];

			if (this.lstToEmail.indexOf(next) == -1) {
				this.lstToEmail = [...this.lstToEmail, next];
			}
		}

		this.StudentRef.SelectedPersons = [];

		this.SelectStudentsExpand = false;
		this.EmailStudentsExpand = true;
	}

	onSendEmail(lstSendEmail: any[]) {
		this.Processing = true;

		var lstPIDs: number[] = [];
		var lstEMs: string[] = [];

		for (var z = 0; z < lstSendEmail.length; z++) {
			var next = lstSendEmail[z];

			if (next.Email != "") {
				lstPIDs = [...lstPIDs, next.PersonID];
				lstEMs = [...lstEMs, next.Email];
			}
		}

		this.CheckValidActivations(lstPIDs, lstEMs);
	}

	CheckValidActivations(lstPIDs: number[], lstEMs: string[]) {
		var parms: CheckValidActivationsRequest = {
			lstPersonIDs: lstPIDs,
		};

		var result = this.idService.EmailCheckValidActivations(parms);
		result.subscribe(
			(response: any) => {
				if (response.length == 0) {
					this.Processing = false;
				} else {
					//All selected schools have enough activations
					if (response[0].AllValid == true) {
						this.FinishEmail(lstPIDs, lstEMs);
					} else {
						var ref = this.dialogService.open(DigitalIdActivationInfoComponent, {
							header: "Not Enough Activations Left",
							width: "fit-content",
							data: {
								//INSERT Custom Data here
								lstTable: response,
							},
						});
						ref.onClose.subscribe((response) => {
							if (response == 1) {
								this.FinishEmail(lstPIDs, lstEMs);
							} else {
								this.Processing = false;
							}
						});
					}
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	FinishEmail(lstPIDs: number[], lstEMs: string[]) {
		var parms: RegisterManualEmailRequest = {
			lstPersonIDs: lstPIDs,
			lstEmails: lstEMs,
		};

		var result = this.idService.RegisterEmail(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				this.lstToEmail = [];
				this.EmailRef.ClearData();
				this.EmailStudentsExpand = false;
				this.EmailRefresh.emit(true);
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onRemovePerson(Person) {
		this.lstToEmail = this.lstToEmail.filter((p) => p.PersonID != Person.PersonID);
	}

	onRemoveAll(val) {
		this.lstToEmail = [];
	}

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////////
	IsLoading() {
		return (
			this.LoadingGradeLevel == true ||
			this.LoadingAcademy == true ||
			this.LoadingHomeroom == true ||
			this.LoadingGroup == true ||
			this.Processing == true
		);
	}
	///////////////////////////////////////////////////////////////////////////
}
